export const RoutesLink = {
    login: "/",
    aiBuddy: "/ai-buddy",
    dashboard: "/dashboard",
    controls: "/controls",
    risks: "/risks",
    policy: "/policy",
    reports: "/reports",
    teamMember: "/team-member",
    frameworks: "/frameworks",
    rolesPermission: "/roles-permission",
    projects: "/projects",
    team: "/team",
    organization: "/organization",
    users: "/users",
    settings: "/settings",

}